import React, { useState, useEffect } from "react";
import { storage, ref, getDownloadURL, listAll } from "./FireBase";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "./Upmenu.css"

const Upmenu = ({ children }) => {
  const [files, setFiles] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [selectedOption, setSelectedOption] = useState("all");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    try {
      const listRef = ref(storage, "uploads/");
      const result = await listAll(listRef);

      const filesData = await Promise.all(
        result.items.map(async (item) => {
          const url = await getDownloadURL(item);
          const filename = item.name;
          const extension = filename.split('.').pop().toLowerCase();

          const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
          const videoExtensions = ["mp4", "mkv", "avi", "mov", "wmv", "flv"];

          let fileType = "other";
          if (imageExtensions.includes(extension)) fileType = "image";
          if (videoExtensions.includes(extension)) fileType = "video";

          return { filename, url, fileType };
        })
      );

      setFiles(filesData);
    } catch (error) {
      console.error("Error fetching files:", error);
    }
  };

  const filteredFiles = files.filter(file => {
    // Convert filename to lowercase for case-insensitive search
    const isMatchingQuery = file.filename?.toLowerCase().includes(searchQuery.toLowerCase());
  
    // If selected option is "all", return all matching files
    if (selectedOption === "all") {
      return isMatchingQuery;
    }
  
    // If "image" is selected, filter only image files
    if (selectedOption === "image") {
      return isMatchingQuery && file.fileType === "image";
    }
  
    // If "video" is selected, filter only video files
    if (selectedOption === "video") {
      return isMatchingQuery && file.fileType === "video";
    }
  
    return false;
  });
  
  

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setIsSearchActive(!!e.target.value);
  };

  const handleFileSelect = (filename) => {
    setSearchQuery(filename);
    setIsSearchActive(false);
    handleSearchSubmit(filename);
  };

  const handleSearchSubmit = (selectedFilename) => {
    let filesToNavigate = selectedFilename
      ? files.filter(file => file.filename === selectedFilename)
      : filteredFiles;
  
    if (filesToNavigate.length > 0) {
      navigate('/search-results', { state: { searchQuery: selectedFilename || searchQuery, files: filesToNavigate } });
  
      // ✅ Clear search input after execution
      setSearchQuery("");
      setIsSearchActive(false);
    }
  };
  
  // ✅ Allow dropdown visibility in /search-results
  const shouldShowDropdown = searchQuery && isSearchActive;

  return (
<div className="outerup" >
{/* <nav className="tab-nav1">
  <ul>
    <li>
      <Link to="/">Home</Link>
    </li>
    <li>
      <Link to="/image">Images</Link>
    </li>
    <li>
      <Link to="/video">Videos</Link>
    </li>
  </ul>
</nav> */}
  <div className="searchcon1">
  <div className="searchinnercontainer">
  <select
    
        value={selectedOption}
        onChange={(e) => setSelectedOption(e.target.value)}
      >

        <option value="all">all</option>
        <option value="image">image</option>
        <option value="video">video</option>
      </select>
    <input
      type="text"
      placeholder="Search by filename"
      value={searchQuery}
      onChange={handleSearchChange}
      style={{
        width: '100%',
        maxWidth: '500px',
        padding: '12px',
        border: '1px solid #ccc',
        borderRadius: '5px',
        fontSize: '16px',
        outline: 'none',
        transition: 'border-color 0.3s ease-in-out',
        boxSizing: 'border-box',
      }}
    />
    <button onClick={() => handleSearchSubmit()}>Search</button>
  </div>
  </div>

  {/* Show dropdown only when there's a search query */}
  {shouldShowDropdown && (
    <div className="dropdown">
      {filteredFiles.length > 0 ? (
        <ul className="dropdown-menu">
          {filteredFiles.map((file, index) => (
            <li key={index} onClick={() => handleFileSelect(file.filename)}>
              {file.filename}
            </li>
          ))}
        </ul>
      ) : (
        <p>No files found</p>
      )}
    </div>
  )}






<div className="content">{children}</div>
</div>


  );
};

export default Upmenu;
